import { FollowTheSigns, HistoryToggleOff, Timer } from "@mui/icons-material";
import {
  LinearProgress,
  Stack,
  SxProps,
  Theme,
  Tooltip,
  Typography,
} from "@mui/material";
import { formatSecondsToDDHHMMSS } from "../libs/utils";
import { formatPercentage } from "../utils/cityEscapeSummary";

export function ChatItemStatsSubheader({
  playRate,
  avgDuration,
  avgTimeFromStart,
  isLoading,
  sx,
}: {
  playRate: number;
  avgDuration?: number;
  avgTimeFromStart?: number;
  isLoading?: boolean;
  sx?: SxProps<Theme>;
}) {
  if (isLoading) {
    return <LinearProgress />;
  }

  return (
    <Stack direction="row" spacing={2} alignItems="center" sx={sx}>
      <Tooltip title="Percentuale di partite in cui si arriva qui">
        <Stack direction="row" spacing={0.75} alignItems="center">
          <FollowTheSigns
            fontSize="small"
            style={{ verticalAlign: "middle" }}
          />
          <Typography>{formatPercentage(playRate)}</Typography>
        </Stack>
      </Tooltip>
      {avgTimeFromStart !== undefined && (
        <>
          <span>{" | "}</span>
          <Tooltip title="Tempo medio di arrivo qui">
            <Stack direction="row" spacing={0.75} alignItems="center">
              <HistoryToggleOff
                fontSize="small"
                style={{ verticalAlign: "middle" }}
              />
              <Typography>
                {formatSecondsToDDHHMMSS(avgTimeFromStart, { first: 3 })}
              </Typography>
            </Stack>
          </Tooltip>
        </>
      )}
      {avgDuration !== undefined && (
        <>
          <span>{" | "}</span>
          <Tooltip title="Durata media trascorsa nella scena">
            <Stack direction="row" spacing={0.75} alignItems="center">
              <Timer fontSize="small" style={{ verticalAlign: "middle" }} />
              <Typography>
                {formatSecondsToDDHHMMSS(avgDuration, { first: 2 })}
              </Typography>
            </Stack>
          </Tooltip>
        </>
      )}
    </Stack>
  );
}
